module.exports = __webpack_public_path__ + "img/betty-logo-2.c22a29c2.svg";